import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOffer } from '../../../types/offer';
import { parseHtmlEntities } from '../../../utils/format';

import * as styles from './index.css';

export interface IDescriptionProps {
  isTitleExperimentActive?: boolean;
  onPageJumped?(label?: string): void;
}

type TDescriptionProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
  IDescriptionProps;

export interface IDescriptionContext {
  offer: IOffer;
}

export class Description extends React.PureComponent<TDescriptionProps> {
  public context: IDescriptionContext;

  public static contextTypes = {
    offer: PropTypes.object,
  };

  public render() {
    const { offer } = this.context;
    const { className } = this.props;
    const description = parseHtmlEntities(offer.description || '');

    let title = '';

    if (this.isShouldShowTitle()) {
      title = parseHtmlEntities(offer.title || '');
    }

    if (!description && !title) {
      return null;
    }

    let descriptionNodes: React.ReactNode[] = [];
    let currentPosition = 0;

    if (description) {
      if (offer.descriptionWordsHighlighted && offer.descriptionWordsHighlighted.length > 0) {
        offer.descriptionWordsHighlighted.forEach(range => {
          descriptionNodes.push(
            description.substring(currentPosition, range[0]),
            <span key={range.toString()} className={styles['label']}>
              {description.substring(range[0], range[1])}
            </span>,
          );
          currentPosition = range[1];
        });

        if (currentPosition < description.length) {
          descriptionNodes.push(description.substring(currentPosition));
        }
      } else {
        descriptionNodes.push(description);
      }
    }

    return (
      <div {...mergeStyles(styles['container'], className)}>
        {this.isShouldShowTitle() &&
          <div className={styles['title']}>
            {title}
          </div>
        }
        { descriptionNodes }
      </div>
    );
  }

  private isShouldShowTitle() {
    const { isTitleExperimentActive } = this.props;
    const { offer: { title, isTop3, isPremium } } = this.context;

    return isTitleExperimentActive && title && (isTop3 || isPremium);
  }
}
